import { cn } from "@/lib/utils";

interface GradientCardProps {
  children: React.ReactNode;
  gradient?: string;
  padding?: string;
}

export const GradientCard = ({
  children,
  gradient = "from-[#3E4651] to-[#20262D]",
  padding = "p-4 touch-device:p-6",
}: GradientCardProps) => {
  return (
    <div className={cn("p-px rounded bg-linear-to-b", gradient)}>
      <div
        className={cn(
          "bg-panel-background rounded shadow-soft-dark-bottom",
          padding,
        )}
      >
        {children}
      </div>
    </div>
  );
};
